'use client'

import dynamic from 'next/dynamic'

const DashboardDemo = dynamic(
  () => import('./hero-demo/dashboard-demo').then((mod) => mod.DashboardDemo),
  {
    ssr: false,
    loading: () => (
      <div className="flex h-[700px] w-full items-center justify-center rounded-[24px] border border-slate-200/60 bg-white/70 shadow-2xl shadow-slate-200/40 dark:border-white/5 dark:bg-[#0b141a]/80 dark:shadow-black/40">
        <div className="h-40 w-40 animate-pulse rounded-full bg-slate-100 dark:bg-white/10" />
      </div>
    ),
  }
)

export function HeroDashboard() {
  return (
    <section className="perspective-1000 relative flex w-full justify-center px-4 md:px-8">
      <div className="motion-safe:animate-float-soft relative w-full max-w-[1200px]">
        {/* Glow Effects */}
        <div className="absolute -inset-1 -z-10 rounded-[32px] bg-gradient-to-r from-blue-500/20 to-cyan-500/20 opacity-60 blur-2xl dark:opacity-30" />
        <div className="absolute -right-12 -top-12 -z-10 h-48 w-48 rounded-full bg-cyan-500/10 blur-[70px] md:h-72 md:w-72 md:blur-3xl" />
        <div className="absolute -bottom-16 -left-16 -z-10 h-52 w-52 rounded-full bg-blue-500/10 blur-[70px] md:h-72 md:w-72 md:blur-3xl" />

        {/* Dashboard Component */}
        <DashboardDemo />

        {/* Reflection / Shine overlay for realism */}
        <div className="pointer-events-none absolute inset-0 z-30 rounded-[28px] ring-1 ring-black/[0.03] dark:ring-white/10" />
      </div>
    </section>
  )
}
